import axios from "axios";

export default function ReceiptFinalizeService(formData, receiptGropId, receiptId) {
  return axios({
    method: 'put',
    url: process.env.REACT_APP_API_HOST + "/receipt/" + receiptGropId + "/" + receiptId + "/finalize",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
